export default __webpack_public_path__ + "images/a18f7c75e689fd6904455400aa8ef3d7-media.webp";